export const STATUS = {
  new: { label: "Νέο", cls: "bg-[#00E676] text-black" },
  contacted: { label: "Επικοινωνήσαμε", cls: "bg-sky-400 text-black" },
  site_visit: { label: "Αυτοψία", cls: "bg-amber-400 text-black" },
  quote_sent: { label: "Προσφορά στάλθηκε", cls: "bg-violet-300 text-black" },
  completed: { label: "Ολοκληρώθηκε", cls: "bg-zinc-600 text-white" },
};
export const SERVICE = { construction: "Κατασκευές", renovation: "Ανακαινίσεις", electrical: "Ηλεκτρολογικά", plumbing: "Υδραυλικά", painting: "Βαφές", other: "Άλλο" };
export const fmt = (iso) => new Date(iso).toLocaleString("el-GR", { dateStyle: "short", timeStyle: "short" });
